import { FieldValues, Control, Path } from 'react-hook-form';
import * as React from 'react';

import { FormControl, FormMessage, FormField, FormItem } from '../form';
import { Input } from '../input/input';
import { cn } from '../../utils';

interface FormInputProps<T extends FieldValues = FieldValues> {
  componentProps?: Partial<React.ComponentProps<typeof Input>>;
  type?: 'password' | 'number' | 'text';
  size?: 'medium' | 'small' | 'large';
  trailingIcon?: {
    position: 'right' | 'left';
    icon: React.ReactNode;
    onClick?: () => void;
  };
  hideErrorMessage?: boolean;
  formControl: Control<T>;
  placeholder?: string;
  required?: boolean;
  floating?: boolean;
  disabled?: boolean;
  className?: string;
  name: Path<T>;
}

export function FormInput<T extends FieldValues>({
  required = false,
  hideErrorMessage,
  componentProps,
  type = 'text',
  trailingIcon,
  placeholder,
  formControl,
  className,
  disabled,
  floating,
  size,
  name,
}: FormInputProps<T>) {
  return (
    <FormField
      render={({ field, formState }) => {
        const hasError = !!formState.errors[field.name];

        return (
          <FormItem className={cn('relative z-0', className)}>
            <FormControl>
              <Input
                {...componentProps}
                {...field}
                trailingIcon={trailingIcon}
                placeholder={placeholder}
                onInput={field.onChange}
                required={required}
                disabled={disabled}
                hasError={hasError}
                floating={floating}
                inputSize={size}
                id={field.name}
                type={type}
              />
            </FormControl>
            {!hideErrorMessage && <FormMessage />}
          </FormItem>
        );
      }}
      control={formControl}
      name={name}
    />
  );
}
